// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordReset_container__hFAPm","message":"PasswordReset_message__ckc17","error":"PasswordReset_error__Q14MN","form":"PasswordReset_form__diD6u"};